import { render, staticRenderFns } from "./AllMarketingObjectTable.vue?vue&type=template&id=8ed81002&scoped=true"
import script from "./AllMarketingObjectTable.vue?vue&type=script&lang=js"
export * from "./AllMarketingObjectTable.vue?vue&type=script&lang=js"
import style0 from "./AllMarketingObjectTable.vue?vue&type=style&index=0&id=8ed81002&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed81002",
  null
  
)

export default component.exports